<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='DeepSeek' subPath='Chat'></bread-crumb>
    <div class="list_container">
      <div v-for="item in list" :key="item.id">
        <div class="chat_request">{{item.request}}</div>
        <div class="chat_response">{{item.response}}</div>
      </div>
    </div>
    <div class="chat_send">
      <el-input class="chat_content" v-model="content" type="textarea" :rows="3" resize="none" placeholder="请输入内容"></el-input>
      <el-button class="chat_btn" @click="sendChat" v-loading.fullscreen.lock="sendLoading">发送</el-button>
    </div>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
export default {
  name: 'deep_seek_chat_list',
  components: {
    'bread-crumb': BreadCrumb
  },
  created () {
    this.getList()
  },
  data () {
    return {
      list: [],
      content: '',
      sendLoading: false
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/deep_seek/chat_list')
      if (res.code === 0) {
        this.list = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async sendChat () {
      this.sendLoading = true
      this.list.push({ id: 0, request: this.content })
      const res = await this.$http.post('/admin/deep_seek/chat', {
        content: this.content
      })
      if (res.code === 0) {
        this.sendLoading = false
        this.content = ''
        const lastIndex = this.list.length - 1
        this.list[lastIndex].id = res.data.id
        this.list[lastIndex].response = res.data.content
      }
    }
  }
}
</script>

<style scoped>
.list_container {
  background-color: #FFFFFF;
  width: 90%;
  height: 600px;
  overflow-y: auto;
  border-radius: 5px;
}
.chat_send {
  background-color: #FFFFFF;
  width: 90%;
  height: 75px;
  margin-top: 5px;
  display: flex;
}
.chat_content {
  width: 95%;
  border: none;
}
.chat_request {
  right: 10px;
  text-align: right;
  margin: 10px;
  display: block;
  font-size: 14px;
}
.chat_response {
  white-space: pre-line;
  max-width: 85%;
  min-width: 10%;
  width: auto;
  margin: 10px 0px 30px 20px;
  padding: 15px;
  color: #FFFFFF;
  font-size: 14px;
  background-color: #808080;
  border-radius: 7px;
}
.chat_btn {
  width: 5%;
  border-left: none;
  font-size: 16px;
  text-align: center;
  letter-spacing: 2px;
}
</style>
